import {
  GET_TEARSHEET_ENTITY_CURRENT_POSITION_REQUEST,
  GET_TEARSHEET_ENTITY_CURRENT_POSITION_SUCCESS,
  GET_TEARSHEET_ENTITY_CURRENT_POSITION_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: null,
  status: statusType.IDLE
}

const position = (state = initial, action) => {
  const { payload, request } = action

  switch (action.type) {
    case GET_TEARSHEET_ENTITY_CURRENT_POSITION_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_TEARSHEET_ENTITY_CURRENT_POSITION_SUCCESS:
      const { factsetEntityId } = request
      return {
        ...state,
        [factsetEntityId]: payload.current,
        status: statusType.SUCCESS
      }

    case GET_TEARSHEET_ENTITY_CURRENT_POSITION_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default position
